import { render } from "./DevSpace.vue?vue&type=template&id=40767ca5"
import script from "./DevSpace.vue?vue&type=script&lang=js"
export * from "./DevSpace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__